import React from 'react';
import { Skeleton } from '@mui/material';
import styles from './skeleton.module.css';

const SkeletonReservationList = ({ borderBottom = true }) => {
  return (
    <>
      <div className="row m-0">
        <div
          className={`col-12 px-1 ${styles.paddingyx} ${borderBottom ? styles.borderBottom : ''}`}
        >
          <div className="row">
            <div className="col pr-0">
              <Skeleton variant="text" sx={{ bgcolor: 'grey.900', fontSize: '1.2rem' }} />
              <Skeleton variant="text" sx={{ bgcolor: 'grey.900', fontSize: '1.2rem' }} />
            </div>
            <div className="col-5 my-auto">
              <Skeleton
                variant="text"
                width={'130px'}
                sx={{ bgcolor: 'grey.900', fontSize: '1.2rem' }}
              />
              <Skeleton variant="text" sx={{ bgcolor: 'grey.900', fontSize: '1.2rem' }} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SkeletonReservationList;